/**
 * Dashboard layout component with shared authenticated navigation
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from '../common/Layout';
import { EmailVerificationBanner } from '../auth/EmailVerificationBanner';

export const DashboardLayout: React.FC = () => {
  return (
    <Layout>
      <EmailVerificationBanner />
      <Outlet />
    </Layout>
  );
};
